import { apiRequestConfig, ApiThunk } from "careand-redux/api/ApiThunks";
import { OperationFunction, OperationId, OpFirstParam, SimpleApiKey, ResponseType } from "careand-redux/api/ApiTypeUtils";
import {store} from "careand-redux/store";
import { getUnwrappedDispatch } from "careand-redux/useAppDispatch";
import MiscUtils from "./MiscUtils";
import { Device } from "./Native/Device";

type EnsureBlob<Tag extends SimpleApiKey, OpId extends OperationId<Tag>> = ResponseType<Tag, OpId> extends Blob ? ApiThunk<Tag, OpId> : never

/**
 * Downloads a file from the BE
 * @Warning EP should return a Blob
 */
export const downloadBlob = async <Tag extends SimpleApiKey, OpId extends OperationId<Tag>> (thunk: EnsureBlob<Tag, OpId>, args: OpFirstParam<OperationFunction<Tag, OpId>>, options: { filename?: string, timeout?: number }) => {
  const [tag, opId] = thunk.typePrefix.split('/') as [Tag, OpId]
  const dispatch = getUnwrappedDispatch(store.dispatch)
  const authenticationToken = store.getState().authentication.token || "";

  if (Device.isMobile()) {
    try {
      const request = apiRequestConfig[tag][opId](args)
      await Device.openFile(authenticationToken, request, options.filename, { timeout: options.timeout })
    } catch (e: unknown) {}
  } else {
    const result = await dispatch(thunk(args), { title: 'File download' })
    if (!result) { return }

    const url = MiscUtils.getBlobUrl(result as Blob)!

    const a = document.createElement('a')
    a.download = options.filename || "File"
    a.href = url
    a.click()
    a.href = ''
  }
}
